import lists from './lists';
import reports from './reports';
import state from './state';
import mutations from './mutations';
import questions from './questions';

export default {
  state,
  mutations,
  actions: {
    ...reports.actions,
    ...lists.actions,
    ...questions.actions,
  },
  getters: {
    ...reports.getters,
    ...lists.getters,
    ...questions.getters,
  },
};
